import React from 'react';
import { useHashRoute } from './router';
import UserHome from './pages/UserHome';
import Guide from './pages/Guide';
import AdminLogin from './pages/AdminLogin';
import AdminLayout from './pages/AdminLayout';
import AdminChannels from './pages/AdminChannels';
import AdminTokens from './pages/AdminTokens';
import AdminSettings from './pages/AdminSettings';
import AdminStats from './pages/AdminStats';
import AdminTokenDetail from './pages/AdminTokenDetail';
import AdminPlans from './pages/AdminPlans';
import AdminTickets from './pages/AdminTickets';
import AdminRisk from './pages/AdminRisk';
import { AgreementGate } from './components/AgreementModal';

function App() {
  const path = useHashRoute();

  // 协议弹窗宿主挂在最外层:任何地方调用 openAgreementDialog() 都会弹这套弹窗
  const page = (() => {
    if (path === '/' || path === '') {
      return <UserHome />;
    }
    if (path === '/guide') {
      return <Guide />;
    }
    if (path === '/admin/login') {
      return <AdminLogin />;
    }
    if (path === '/admin' || path === '/admin/stats') {
      return <AdminLayout><AdminStats /></AdminLayout>;
    }
    if (path === '/admin/channels') {
      return <AdminLayout><AdminChannels /></AdminLayout>;
    }
    if (path === '/admin/tokens') {
      return <AdminLayout><AdminTokens /></AdminLayout>;
    }
    if (path.startsWith('/admin/tokens/')) {
      return <AdminLayout><AdminTokenDetail /></AdminLayout>;
    }
    if (path === '/admin/plans') {
      return <AdminLayout><AdminPlans /></AdminLayout>;
    }
    if (path === '/admin/settings') {
      return <AdminLayout><AdminSettings /></AdminLayout>;
    }
    if (path === '/admin/tickets') {
      return <AdminLayout><AdminTickets /></AdminLayout>;
    }
    if (path === '/admin/risk') {
      return <AdminLayout><AdminRisk /></AdminLayout>;
    }
    if (path.startsWith('/admin')) {
      return <AdminLayout><AdminStats /></AdminLayout>;
    }

    return <UserHome />;
  })();

  return (
    <>
      {page}
      <AgreementGate />
    </>
  );
}

export default App;